module.exports = __webpack_public_path__ + "img/sight_select.f496c959.png";